import React, {useState, useEffect} from "react";
import axios from 'axios';
import './style.css';
// import parse from 'html-react-parser';
import Loading from '../../itens/loading.js';

const Presentes = () => {
  const [presentes, setPresentes] = useState([])

  useEffect(()=>{
    axios.get(`${window.location}/?rest_route=/wp/v2/presents`)
    .then((res) => {
      setPresentes(res.data)
    })
    .catch((err) => {
        console.error(err)
    })
  },[])

  return (
    <div className="presentes-section">
      <h2>Lista de Presentes</h2>
      <div id="presentes" className="listPresents">
      {presentes.length > 0 ? (
        presentes?.map((presente) => 
          <div className="box-present" key={presente.id}>
            <a href={presente.permalink}>
              <div className="img-presente-home">
                {presente.images.map((img) => 
                  <img className="imgProduct" src={img.src} />
                )}
              </div>
              <p>{presente.name}</p>
              <span dangerouslySetInnerHTML={{ __html: presente.price_html }} />
            </a> 
          </div>
        )
      ):(
        <Loading />
      )}
        <div className="box-ver-mais">
          <a href="https://uaicasei.com/loja" >Ver mais</a>
        </div>
      </div>
    </div>
  )
}

export default Presentes